import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CartPreviewMHComponent } from './cart-preview.component';
import { CartPreviewItemMHComponent } from './item/cart-preview-item.component';
import { PriceSimpleMHComponent } from '../../price/simple/price-simple.component';
import { PriceMissingInfoIconMHComponent } from '../../price/price-missing-info-icon/price-missing-info-icon.component';
import { QuantityInputBareModule } from '../../quantity-input/quantity-input-bare/quantity-input-bare.module';
import { PriceFormatModule } from '../../price/format/price-format.module';
import { ProductDeleteIconModule } from '../../product/delete-icon/product-delete-icon.module';
import { AddressDetailComponent } from 'projects/shared/lib/components/shared/address/detail/address-detail.component';
import { CartValidationResultComponent } from 'projects/shared/lib/components/shared/cart/validation/result/cart-validation-result.component';
import { CartValidationResultCartItemComponent } from 'projects/shared/lib/components/shared/cart/validation/result/cart-item/cart-validation-result-cart-item.component';
import { CartValidationResultCartComponent } from 'projects/shared/lib/components/shared/cart/validation/result/cart/cart-validation-result-cart.component';
import { CartItemFilterInvalidPipe } from 'projects/shared/lib/pipes/validation/cart/item/filter/invalid/cart-item-filter-invalid.pipe';
import { CartItemFilterValidPipe } from 'projects/shared/lib/pipes/validation/cart/item/filter/valid/cart-item-filter-valid.pipe';
import { LoadingIndicatorComponent } from 'projects/shared/lib/components/shared/base/loading-indicator/loading-indicator.component';
import { PriceDepositModule } from '../../price/deposit/price-deposit.module';
import { PriceBasePriceModule } from '../../price/base-price/price-base-price.module';
import { CartPreviewItemInactiveMHComponent } from './item-inactive/cart-preview-item-inactive.component';
import { PromotionInfoPictogramComponent } from 'projects/shared/lib/components/shared/promotion/promotion-info-pictogram/promotion-info-pictogram.component';
import { PromotionInfoShortComponent } from 'projects/shared/lib/components/shared/promotion/promotion-info-short/promotion-info-short.component';
import { ProductTagListComponent } from 'projects/shared/lib/components/shared/product/tag/list/product-tag-list.component';
import { QuantityUnitToStringPipe } from 'projects/shared/lib/pipes/quantity-unit/quantity-unit-to-string.pipe';
import { CartPreviewInfoComponent } from 'projects/shared/lib/components/shared/cart/preview/info/app-cart-preview-info.component';


@NgModule({
  declarations: [
    CartPreviewMHComponent,
    CartPreviewItemMHComponent,
    CartPreviewItemInactiveMHComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,

    PriceSimpleMHComponent,
    PriceMissingInfoIconMHComponent,
    QuantityInputBareModule,
    PriceFormatModule,
    ProductDeleteIconModule,
    AddressDetailComponent,
    CartValidationResultComponent,
    CartValidationResultCartItemComponent,
    CartValidationResultCartComponent,
    CartItemFilterInvalidPipe,
    CartItemFilterValidPipe,
    LoadingIndicatorComponent,
    PriceDepositModule,
    PriceBasePriceModule,
    QuantityUnitToStringPipe,
    PromotionInfoPictogramComponent,
    PromotionInfoShortComponent,
    ProductTagListComponent,

    CartPreviewInfoComponent,
  ],
  exports: [
    CartPreviewMHComponent,
  ]
})
export class CartPreviewModule { }
